const houseList = document.querySelector('.house-list');

if (houseList) {
  const houseListModelsData = () => {
    const modelsEl = houseList.querySelectorAll('input[name="house_list_models"]:checked');
    return [...modelsEl].map((model) => model.value);
  };

  // get house matrix info
  const houseListRow = houseList.querySelector('.house-list__row');
  const axiosGetHouseList = async () => {
    const action = 'getHouseList';
    const formDataInput = {
      action,
      models: houseListModelsData(),
      rooms: houseList.querySelector('input[name="house_list_rooms"]:checked')?.value,
      bedrooms: houseList.querySelector('input[name="house_list_bedrooms"]:checked')?.value,
      rangeStart: houseList.querySelector('#range_start').value,
      rangeEnd: houseList.querySelector('#range_end').value,
      nonce: await getNonceForAction(action),
    };

    try {
      const response = await axios.post(localData.siteURL, formDataInput);
      houseListRow.innerHTML = response.data.data.html_house_list || response.data.data.text__not_found;

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['models', 'rangeStart', 'rangeEnd', 'rooms', 'bedrooms']
        .map((param) => {
          const value = formDataInput[param];
          if (!value || (Array.isArray(value) && !value.length)) {
            return null;
          }

          if (Array.isArray(value)) {
            return `${param}=${value.join(',')}`;
          }

          return `${param}=${value}`;
        })
        .filter(Boolean)
        .join('&');

      window.history.pushState({}, '', `${baseUrl}${urlParams ? `?${urlParams}` : ''}`);
    } catch (err) {
      console.error(err);
    }
  };

  attachEvent(
    '.house-list .product-filter__item--checkboxes input, .house-list .product-filter__item--radios input',
    'change',
    () => {
      axiosGetHouseList();
    },
  );

  attachEvent('.house-list #range_start, .house-list #range_end', 'input', () => {
    axiosGetHouseList();
  });
}
